import { ICertInfo } from "./user.types";

export class CertInfo implements ICertInfo {
  readonly certYesNo: boolean;

  constructor(data: ICertInfo) {
    this.certYesNo = data.certYesNo;
  }
}
